import { Component, OnInit } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { StatusDocumentoAssinatura } from 'src/app/pages/call-center/pages/projects/models/status-documento';
import { UploadArquivo } from 'src/app/pages/call-center/pages/projects/models/uplaod-arquivo';
import { AssinarDocumentoService } from 'src/app/pages/call-center/pages/projects/services/assinar-documento.service';
import { ToastService } from 'src/app/shared/toasts/toast-service';

@Component({
  selector: 'app-upload-documento',
  templateUrl: './upload-documento.component.html',
  styleUrl: './upload-documento.component.scss'
})
export class UploadDocumentoComponent implements OnInit {
  isLoading: boolean = false;

  statusDocumento!: StatusDocumentoAssinatura;
  uploadArquivoForm!: FormGroup;
  file: File | null = null;
  contratoId = "";

  constructor(
    private route: ActivatedRoute,
    private assinarDocumentoService: AssinarDocumentoService,
    private toastService: ToastService,
    private fb: FormBuilder) {
    this.uploadArquivoForm = this.fb.group({
      document: [null, [Validators.required]]
    });
  }

  ngOnInit(): void {

    this.contratoId = this.route.snapshot.paramMap.get('id')!;

    //this.consultarDocumentoAssinatura(this.contratoId);
  }

  onSubmit() {
    this.isLoading = true;

    if (this.uploadArquivoForm.invalid) {
      this.uploadArquivoForm.markAllAsTouched();

      //Iterar sobre os campos e exibir os erros
      Object.keys(this.uploadArquivoForm.controls).forEach((field) => {
        const control = this.uploadArquivoForm.get(field);
        if (control?.errors) {
        }
      });

      return;
    }

    const uploadArquivo: UploadArquivo = {
      documento: this.file!, // do tipo File
      contratoId: this.contratoId,
    };

    const formData = new FormData();
    formData.append('ContratoId', uploadArquivo.contratoId);
    formData.append('Documento', uploadArquivo.documento!);

    this.assinarDocumentoService.uploadArquivo(formData).subscribe({
      next: () => {

        this.toastService.show("Arquivo enviado com sucesso", {
          classname: "bg-success text-light",
        });

        //this.consultarDocumentoAssinatura(this.contratoId);

        setTimeout(() => {
          window.location.reload();
        }, 3000);

         this.isLoading = false;
      },
      error: () => {
        this.toastService.show("Erro ao tentar enviar arquivo", {
          classname: "bg-danger text-light",
        });
         this.isLoading = false;
      },
    });
  } 

  onChange(event: any) {
    const file: File = event.target.files[0];

    if (file) {
      this.file = file;
    }
  }
}
